import { TranslationParam } from "./types";
import axios from "axios";
import { leadCreated } from "./common/analytics";
import { ADD_LEADS_URL } from "./constants";

export function urlToLocale(pathname: string = "") {
  const locale = pathname.substring(1, 6);
  const localeList = locale.split("-");

  if (localeList.length < 2) {
    return [];
  }

  if (localeList[0].length < 2 || localeList[1].length < 2) {
    return [];
  }

  return localeList;
}

function getTranslationSource() {
  const lang = urlToLocale(window.location.pathname)[0];
  let translations;
  try {
    translations = require(`../src/locale/${lang}.json`);
  } catch (err) {
    translations = require(`../src/locale/en.json`);
  }
  return translations;
}

export const t = (key: string = "", params: TranslationParam = {}) => {
  let translations = getTranslationSource();
  let trans: any = translations;

  try {
    const nestedKeysList = key.split(".");
    nestedKeysList.forEach((k: string) => {
      trans = typeof trans === "string" ? trans : trans[k];
    });
  } catch (err) {
    trans = key;
  }

  try {
    for (key in params) {
      trans =
        typeof trans === "string"
          ? trans.replace("{{" + key + "}}", params[key])
          : trans[key].replace("{{" + key + "}}", params[key]);
    }
  } catch (err) {
    console.error(err);
  }

  return trans;
};

export function addLead(payload) {
  payload["origin"] = "promotions.cocunat.com";
  leadCreated(payload);
  return axios.post(`${ADD_LEADS_URL}create`, payload);
}

export function getLead(email) {
  return axios.get(`${ADD_LEADS_URL}list?email=${email}`);
}

export function getURLParams(search) {
  if (!search) {
    return {};
  }
  return search
    .slice(1)
    .split("&")
    .map((p) => p.split("="))
    .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
}
